export const choreDisabledTranslateEs = {
    DISABLED_VIEW:{
      TITLE: "Las tareas domésticas acaban de volverse más fáciles gracias a la aplicación.",
      DESCRIPTION: "Estamos trasladando las tareas a nuestra aplicación para brindarte una experiencia más dinámica y accesible.",
      BUTTON: "Bajar la aplicacion de Modak"
    }
  }